module.exports = __webpack_public_path__ + "media/images/brands/logo_energie_experten-535a69561558cc6c3ee28586d8400f09.svg";